(function () {
    'use strict';

    angular.module('Services').factory('PostcodeBaseMarginsTableService', PostcodeBaseMarginsTableService);

    PostcodeBaseMarginsTableService.$inject = [
        'toastr',
        'Location',
        '$q',
        '$timeout',
        '$filter',
        '$rootScope'
    ];

    function PostcodeBaseMarginsTableService(
        toastr,
        Location,
        $q,
        $timeout,
        $filter,
        $rootScope
    ) {
        return function (form, clientService) {
            let service = clientService;
            let dataCopy = [];

            let country = {
                url: '/templates/pages/services/add-ons/tableBody/editableCountry.html',
                value: null
            };
            let postcode = {
                url: '/templates/pages/services/add-ons/tableBody/editablePostcode.html',
                value: null
            };
            let marginValue = {
                url: '/templates/pages/services/add-ons/tableBody/editableText.html',
                value: null
            };
            let actionBtns = function (isNew) {
                return {
                    type: 'button',
                    buttons: [{
                        class: isNew ? 'btn btn-success btn-circle glyphicon glyphicon-ok' :
                            'btn btn-primary btn-circle glyphicon glyphicon-pencil',
                        action: row => {
                            tableStructure.form.$setSubmitted();
                            if (tableStructure.form.$invalid){
                                return false;
                            }
                            row.isSelected = false;
                            $timeout(() => {
                                if (!row.editMode) {
                                    tableStructure.form.$setUntouched();
                                    tableStructure.form.$setPristine();
                                    tableStructure.headers.map(header => {
                                        row[header.viewName].valTemp = angular.copy(row[header.viewName].value);
                                    });
                                    row.editMode = !row.editMode;
                                } else {
                                    if (tableStructure.form.$valid) {
                                        tableStructure.headers.map(header => {
                                            row[header.viewName].value = angular.copy(row[header.viewName].valTemp) || 0;
                                            row[header.viewName].valueFormatted =
                                                (angular.copy(row[header.viewName].valTemp) || 0)
                                                + (header.viewName === 'fixedMargin' ? ' '
                                                    + (service.serviceProfile.currency || 'AUD') : ' %');
                                        });
                                        row.editMode = !row.editMode;
                                    }
                                }
                                changeButtons(row);
                                $rootScope.$broadcast('postcodeBasedMarginsTableUpdate', 'updated');
                            });
                        }
                    }, {
                        class: isNew ? 'btn btn-danger btn-circle glyphicon glyphicon-remove'
                            : 'btn btn-danger btn-circle glyphicon glyphicon-trash',
                        action: row => {
                            if (row.editMode && !row.isNewMargin) {
                                row.editMode = false;
                                changeButtons(row);
                                return false;
                            }
                            tableStructure.data.splice(tableStructure.data.indexOf(row), 1);
                            $rootScope.$broadcast('postcodeBasedMarginsTableUpdate', 'updated');
                        }
                    }]
                };
            };

            const tableStructure = {
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: true,
                    tableMinHeight: '15em'
                },
                form: form,
                headers: [{
                    label: 'Country',
                    viewName: 'countryObj'
                },
                {
                    label: 'Postcode From',
                    viewName: 'postcodeRangeStart'
                }, {
                    label: 'Postcode To',
                    viewName: 'postcodeRangeEnd'
                }, {
                    label: 'Fixed Margin',
                    viewName: 'fixedMargin'
                }, {
                    label: 'Margin %',
                    viewName: 'percentMargin'
                }, {
                    label: 'Actions',
                    viewName: 'actions'
                }],
                data: [],
                onInit: () => {
                    $timeout(() => {
                        buildTableData(angular.getObjVal(clientService, 'postcodeMargins.regions') || [], clientService, true);
                    });
                },
                clearZones: row => {
                    row.postcodeRangeEnd.valTemp = null;
                    row.postcodeRangeStart.valTemp = null;
                },
                roundDown: model => {
                    return parseFloat(parseFloat(model).roundDown(2))
                },
                postcodeTooltip: '', // need to remove this one
                searchCountry: (select, row, col) => {
                    row.isSearching = true;
                    if(select.open){
                        row.items = [];
                        getCountries().then(data=>{
                            row.items = data;
                        });
                    } else {
                        row.isSearching = false;
                    }
                },
                searchPostcode: (select, row, col) => {
                    row.isSearching = true;
                    if(select.open){
                        row.items = [];
                        if(row.countryObj.value !== null) {
                            searchPostCodes(row.countryObj.value, select).then(data=>{
                                if(data.length == 0){
                                    row.items.push({
                                        code: "No Data Available"
                                    });
                                } else {
                                    row.items = data.filter( postCode => postCode.code != "");
                                }
                                row.isSearching = false;
                            });
                        }
                        else if(row.countryObj.valTemp !== null) {
                            searchPostCodes(row.countryObj.valTemp, select).then(data=>{
                                if(data.length == 0){
                                    row.items.push({
                                        code: "No Data Available"
                                    });
                                } else {
                                    row.items = data.filter( postCode => postCode.code != "");
                                }
                                row.isSearching = false;
                            });
                        }
                    }
                }
            };
            function getCountries(){
                const deffered = $q.defer(); 
                Location.Country({
                }, (data) => {
                    deffered.resolve(data);
                }, (error) => {
                    deffered.reject(error);
                    toastr.error(error.message, error.code);
                });
                return deffered.promise;
            }
            function searchPostCodes(country, select){
                const deffered = $q.defer();
                Location.ZipCode({
                    country: country.code,
                    size: 20,
                    sort: 'code',
                    code: select.search
                }, (data) => {
                    deffered.resolve(data.content);
                }, (error) => {
                    deffered.reject(error);
                    toastr.error(error.message, error.code);
                });
                return deffered.promise;
            }
            function changeButtons(row) {
                if (row.editMode) {
                    row.actions.buttons[0].class = 'btn btn-success btn-circle glyphicon glyphicon-ok';
                    row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-remove';
                    return false;
                }
                row.actions.buttons[0].class = 'btn btn-primary btn-circle glyphicon glyphicon-pencil';
                row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-trash';
            }
            
            function buildTableData(items, clientService, createCopy) {
                service = clientService;
                angular.forEach(items, function (row, index) {
                    row.actions = actionBtns();
                    row.fixedMargin = angular.extend(angular.copy(marginValue), {
                        value: row.marginFixed,
                        valueFormatted: $filter('bbaCurrency')(row.marginFixed, service.serviceProfile.currency),
                        addOn: service.serviceProfile.currency || 'AUD'
                    });
                    row.percentMargin = angular.extend(angular.copy(marginValue), {
                        value: row.marginPercent,
                        valueFormatted: row.marginPercent + ' %'
                    });
                    row.countryObj = angular.extend(angular.copy(country), {
                        value: row.country
                    });
                    row.postcodeRangeStart = angular.extend(angular.copy(postcode), {
                        value: row.postcodeRangeStart
                    });
                    row.postcodeRangeEnd = angular.extend(angular.copy(postcode), {
                        value: row.postcodeRangeEnd
                    });
                    tableStructure.data.push(row);
                    if (createCopy) {
                        dataCopy.push(angular.copy(row));
                    }   
                });
            }

            function resetTableData() {
                tableStructure.data.length = 0;
                angular.forEach(dataCopy, data => tableStructure.data.push(data));
            }
            function addNewMargin() {
                tableStructure.form.$setSubmitted();
                if (tableStructure.form.$invalid) {
                    return false;
                }
                const onEditMode = tableStructure.data.find(data => {
                    if (data.editMode) {
                        data.isSelected = true;
                        return true
                    }
                    return false
                });
                if (onEditMode) {
                    return false;
                }
                $timeout(() => {
                    tableStructure.form.$setUntouched();
                    tableStructure.form.$setPristine();
                    const row = {
                        countryObj: angular.copy(country),
                        postcodeRangeStart: angular.copy(postcode),
                        postcodeRangeEnd: angular.copy(postcode),
                        fixedMargin: angular.extend(angular.copy(marginValue), {
                            addOn: service.serviceProfile.currency || 'AUD'
                        }),
                        percentMargin: angular.copy(marginValue),
                        actions: actionBtns(true),
                        editMode: true,
                        isNewMargin: true
                    };
                    tableStructure.data.push(row);
                    $rootScope.$broadcast('postcodeBasedMarginsTableUpdate', 'updated');
                });
            }
            function getPostcodeMarginFormatted() {
                let filteredData = tableStructure.data.filter(value => {
                    return !value.editMode;
                });
                return filteredData.map(row => {
                    return {
                        country: angular.getObjVal(row, 'countryObj.value.code'),
                        postcodeRangeStart: angular.getObjVal(row, 'postcodeRangeStart.value.code'),
                        postcodeRangeEnd: angular.getObjVal(row, 'postcodeRangeEnd.value.code'),
                        marginFixed: angular.getObjVal(row, 'fixedMargin.value') || 0,
                        marginPercent: angular.getObjVal(row, 'percentMargin.value') || 0
                    }
                });
            }
            function getOpenForms() {
                let openFrm = tableStructure.data.filter(value => {
                    if (value.editMode) {
                        return value;
                    }
                });
                return openFrm.length !== 0 ? true : false;
            }
            this.tableData = tableStructure;
            this.refreshTable = buildTableData;
            this.resetTableData = resetTableData;
            this.addNewMargin = addNewMargin;
            this.getPostcodeMarginFormatted = getPostcodeMarginFormatted;
            this.getOpenForms = getOpenForms;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/PostcodeBaseMarginsTableService.js